<template>
  <div class="collectBox">
    <div class="titleBox">
      <div class="titleLeft">
        <img
          src="../../assets/images/titleArrow.png"
          alt=""
          @click="returnTopic()"
        />
      </div>
      <div class="titleCentre">我的错题</div>
      <div class="titleRight" @click="showPopup">
        <!-- <img src="../../assets/images/centreIcon.png" alt="" /> -->
      </div>
    </div>
    <div class="notBox" v-if="!directoryList || directoryList.length === 0">
      <img src="../../assets/images/None.png" alt="" />
      <span>暂无数据</span>
    </div>
    <van-tabs
      v-else
      v-model="active"
      class="tabBox"
      line-width="14px"
      line-height="3px"
      color="#1BBF8D"
      title-inactive-color="#333333"
      title-active-color="#121212"
      swipeable
      @click="onTabClick"
    >
      <van-tab
        :title="item.label"
        v-for="(item, index) in directoryList"
        :key="index"
      >
        <div class="haveBox" v-if="topicList.length > 0">
          <li
            v-for="(item, index) in topicList"
            :key="index"
            @click="topicClick"
          >
            {{ index + 1 }}.{{ item.content }}
          </li>
        </div>
        <div class="notBox" v-else>
          <img src="../../assets/images/None.png" alt="" />
          <span>暂无数据</span>
        </div>
      </van-tab>
    </van-tabs>
    <van-popup v-model="show" position="bottom" round class="popupBox">
      <ul class="popupUl">
        <li
          class="popupLi"
          :class="{ active: allCheck }"
          @click="allCheckClick"
        >
          <span>全部</span>{{ allTopic }}
        </li>
        <li
          class="popupLi"
          v-for="(item, index) in titleList"
          :key="index"
          :class="{ active: item.check }"
          @click="checkClick(item)"
        >
          <span>{{ item.categoryName }}</span
          >{{ item.totalNum }}
        </li>
      </ul>
      <div class="btnBox">
        <div class="resetBtn" @click="resetBtnClick">重置</div>
        <div class="completeBtn" @click="completeClick">完成</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {
  getWrongAnswerQuestions,
  getWrongAnswerCategory,
} from "@/api/subject/index.js";
export default {
  data() {
    return {
      studyBankId: "",
      directoryList: [],
      active: 0,
      show: false,
      categoryIds: [],
      allTopic: "",
      allCheck: true,
      titleList: [],
      topicList: [],
      majorType: "",
    };
  },
  created() {
    this.studyBankId = this.$route.query.studyBankId;
    this.majorType = this.$route.query.majorType;
    this.directory();
  },
  methods: {
    async directory(flag) {
      this.categoryIds = [];
      const setList = {
        majorType: this.majorType,
      };
      const { data } = await getWrongAnswerCategory("", setList);
      this.directoryList = data[0].children;
      this.allTopic = this.directoryList[this.active].totalNum;
      if (flag != "reset") {
        this.titleList = this.directoryList[this.active].children.map(
          (item) => {
            return {
              ...item,
              check: true,
            };
          }
        );
      }
      this.titleList.forEach((item) => {
        if (item.check) {
          this.categoryIds.push(item.id);
        }
      });
      this.getQuestionsListData();
    },
    async getQuestionsListData() {
      const setList = {
        categoryIds: this.categoryIds,
        majorType: this.majorType,
      };
      const { data } = await getWrongAnswerQuestions(setList);
      this.topicList = data;
    },
    onTabClick(title) {
      this.active = title;
      this.directory();
    },
    showPopup() {
      this.show = true;
      const categoryIdSet = new Set(this.categoryIds);
      this.titleList.forEach((value) => {
        value.check = categoryIdSet.has(value.categoryId);
      });
      this.allCheck = this.titleList.every((item) => item.check);
    },
    allCheckClick() {
      this.allCheck = !this.allCheck;
      if (this.allCheck) {
        this.titleList.forEach((item) => {
          item.check = true;
        });
      } else {
        this.titleList.forEach((item) => {
          item.check = false;
        });
      }
    },
    checkClick(item) {
      item.check = !item.check;
      if (!item.check) {
        this.allCheck = false;
      } else {
        this.allCheck = this.titleList.every((item) => item.check);
      }
    },
    resetBtnClick() {
      this.allCheck = false;
      this.titleList.forEach((item) => {
        item.check = false;
      });
      this.show = false;
      this.directory("reset");
    },
    completeClick() {
      this.categoryIds = [];
      this.titleList.forEach((item) => {
        if (item.check) {
          this.categoryIds.push(item.id);
        }
      });
      this.getQuestionsListData();
      this.show = false;
    },
    returnTopic() {
      this.$router.push({
        path: "/subject",
        query: {
          majorType: this.$route.query.majorType,
        },
      });
    },
    topicClick() {
      let categoryIdsString = JSON.stringify(this.categoryIds);
      this.$router.push({
        path: "/subjectHomeWork",
        query: {
          // studyBankId: this.studyBankId,
          categoryIds: categoryIdsString,
          typeFlag: 2,
          setUpTypes: 1,
          type: 1,
          name: "errorCorrection",
          majorType: this.$route.query.majorType,
        },
      });
    },
  },
};
</script>


<style lang="scss" scoped>
.collectBox {
  position: fixed;
  top: 0%;
  left: 0%;
  right: 0%;
  bottom: 0%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    180deg,
    rgba(196, 249, 247, 0.5) 0%,
    rgba(255, 255, 255, 0.5) 135px
  );
  .titleBox {
    padding: 44px 16px 0 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 88px;
    .titleLeft {
      width: 20px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      img {
        width: 20px;
        height: 20px;
      }
    }
    .titleCentre {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 17px;
      color: #121212;
      text-align: left;
      font-style: normal;
    }
    .titleRight {
      width: 28px;
      height: 28px;
      line-height: 28px;
      text-align: center;
      border-radius: 50%;
      // background: rgba(27, 191, 141, 0.1);
      display: flex;
      justify-content: center;
      align-items: center;
      transition: transform 200ms ease;
      backface-visibility: hidden;
      img {
        width: 14px;
        height: 14px;
      }
    }
  }
  .notBox {
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: calc(100vh - 123px);
    img {
      width: 113px;
      height: 106px;
    }
    span {
      margin-top: 10px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #aaaaaa;
      line-height: 17px;
      text-align: center;
      font-style: normal;
    }
  }
  .tabBox {
    width: 100%;
    padding: 0 16px;
    // flex: none !important;
    ::v-deep .van-tab {
      /* 强制去除这个  可以解决文本过长   不显示问题*/
      -webkit-flex: none !important;
    }
    ::v-deep .van-tabs__wrap {
      margin-bottom: 7px;
      height: 35px !important;
      .van-tabs__nav {
        height: 35px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        line-height: 22px;
        text-align: center;
        font-style: normal;
        background-color: transparent;
        .van-tab--active {
          font-weight: 500;
          font-size: 17px;
        }
      }
    }
    ::v-deep .van-tabs__content {
      .haveBox {
        li {
          list-style: none;
          height: 47px;
          border-bottom: 1px solid #eeeeee;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 15px;
          color: #333333;
          line-height: 47px;
          text-align: left;
          font-style: normal;
          white-space: nowrap; /* 文本不换行 */
          overflow: hidden; /* 隐藏溢出的文本 */
          text-overflow: ellipsis; /* 显示省略号 */
        }
      }
      .notBox {
        display: flex;
        flex-flow: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: calc(100vh - 123px);
        img {
          width: 113px;
          height: 106px;
        }
        span {
          margin-top: 10px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 12px;
          color: #aaaaaa;
          line-height: 17px;
          text-align: center;
          font-style: normal;
        }
      }
    }
  }
  .popupBox {
    padding: 30px 19px 38px 16px;
    .popupUl {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start; /* 靠左排列 */
      .popupLi:nth-child(3n) {
        margin-right: 0px;
      }
      .popupLi {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 6px 10px;
        margin-bottom: 9px;
        margin-right: 2%;
        width: 32%;
        height: 32px;
        background: #f5f5f5;
        border-radius: 4px;
        list-style: none;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        font-style: normal;
        border: 1px solid #f5f5f5;
        span {
          margin-right: 5px;
          white-space: nowrap; /* 文本不换行 */
          overflow: hidden; /* 隐藏超出部分 */
          text-overflow: ellipsis; /* 显示省略号 */
          // width: 100%; /* 确保文本容器的宽度 */
        }
        &.active {
          color: #1bbf8d;
          background: rgba(27, 191, 141, 0.1);
          border: 1px solid rgba(27, 191, 141, 0.5);
        }
      }
    }
    .btnBox {
      display: flex;
      margin-top: 90px;
      width: 100%;
      height: 44px;
      .resetBtn {
        width: 50%;
        height: 44px;
        background: rgba(27, 191, 141, 0.1);
        border-radius: 22px 0px 0px 22px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #1bbf8d;
        line-height: 44px;
        text-align: center;
        font-style: normal;
      }
      .completeBtn {
        width: 50%;
        height: 44px;
        background: #1bbf8d;
        border-radius: 0px 22px 22px 0px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #ffffff;
        line-height: 44px;
        text-align: center;
        font-style: normal;
      }
    }
  }
}
</style>